import React from 'react';
import { Button, Checkbox, Input, InputNumber, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { FB651 } from '../../../services/b255Api';

type DetailRow = Omit<FB651, 'fb651_01' | 'fb651_02'>;

interface Props {
  rows: DetailRow[];
  isEditing: boolean;
  onUpdate: (idx: number, field: keyof DetailRow, value: unknown) => void;
  onDelete: (idx: number) => void;
  onAdd: () => void;
  totalCount: number;
  totalAmount: number;
}

const DetailTable: React.FC<Props> = ({ rows, isEditing, onUpdate, onDelete, onAdd, totalCount, totalAmount }) => {
  const columns: ColumnsType<DetailRow> = [
    { title: '項次', key: 'index', width: 55, render: (_, __, idx) => idx + 1 },
    {
      title: '產品代號', dataIndex: 'fb651_11', width: 130,
      render: (val: string, _, idx) => isEditing
        ? <Input value={val} size="small" onChange={e => onUpdate(idx, 'fb651_11', e.target.value)} />
        : val,
    },
    { title: '產品名稱', dataIndex: 'fb651_11a', width: 160, render: (v: string) => <span style={{ color: '#555' }}>{v}</span> },
    {
      title: '單位', dataIndex: 'fb651_12', width: 60,
      render: (val: string, _, idx) => isEditing
        ? <Input value={val} size="small" style={{ width: 55 }} onChange={e => onUpdate(idx, 'fb651_12', e.target.value)} />
        : val,
    },
    {
      title: '數量', dataIndex: 'fb651_13', width: 90,
      render: (val: number, _, idx) => isEditing
        ? <InputNumber value={val} size="small" min={0} style={{ width: 80 }} onChange={v => onUpdate(idx, 'fb651_13', v ?? 0)} />
        : val,
    },
    {
      title: '單價', dataIndex: 'fb651_14', width: 90,
      render: (val: number, _, idx) => isEditing
        ? <InputNumber value={val} size="small" min={0} style={{ width: 80 }} onChange={v => onUpdate(idx, 'fb651_14', v ?? 0)} />
        : val,
    },
    { title: '金額', dataIndex: 'fb651_15', width: 90, render: (v: number) => v?.toLocaleString() },
    {
      title: '摘要', dataIndex: 'fb651_18',
      render: (val: string, _, idx) => isEditing
        ? <Input value={val} size="small" onChange={e => onUpdate(idx, 'fb651_18', e.target.value)} />
        : val,
    },
    {
      title: '簽收', dataIndex: 'fb651_85', width: 60, align: 'center' as const,
      render: (val: boolean, _, idx) => (
        <Checkbox checked={val} onChange={e => onUpdate(idx, 'fb651_85', e.target.checked)} />
      ),
    },
    ...(isEditing ? [{
      title: '', key: 'del', width: 50,
      render: (_: unknown, __: unknown, idx: number) => (
        <Button type="link" danger size="small" onClick={() => onDelete(idx)}>刪除</Button>
      ),
    }] : []),
  ];

  return (
    <>
      {isEditing && (
        <div style={{ marginBottom: 8 }}>
          <Button size="small" onClick={onAdd}>明細新增</Button>
        </div>
      )}
      <Table dataSource={rows} columns={columns} rowKey={(_, idx) => String(idx)} size="small" pagination={false} scroll={{ x: 800 }} />
      <div style={{ display: 'flex', gap: 24, padding: '8px 0', fontWeight: 500 }}>
        <span>總項數: {totalCount}</span>
        <span>合計金額: {totalAmount?.toLocaleString()}</span>
      </div>
    </>
  );
};

export default DetailTable;
